// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-d3e60062]{height:100px;width:100px;background-color:gray;border-radius:100px}.avatar img[data-v-d3e60062]{height:100%;width:100%}.link[data-v-d3e60062]{background-color:#e8e8e8;border-radius:18px;padding:10px 15px 10px 15px;margin:10px 0px 10px 0px;width:100%}.link a[data-v-d3e60062]{color:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
